import {
    DEALERMULTIPLEMAPPINGLIST_SUCCESS,
    DEALERMULTIPLEMAPPINGLIST_FAILED,
    RESET_DEALERMULTIPLEMAPPINGLIST,
    LOADING_DEALERMULTIPLEMAPPINGLIST,
    NETWORK_ERROR_DEALERMULTIPLEMAPPINGLIST
} from '../types/index'

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_DEALERMULTIPLEMAPPINGLIST:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case DEALERMULTIPLEMAPPINGLIST_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case DEALERMULTIPLEMAPPINGLIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_DEALERMULTIPLEMAPPINGLIST:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_DEALERMULTIPLEMAPPINGLIST:
            return (state = initialState);
        default:
            return state;
    }
};